import React from 'react';
import Box from '@mui/material/Box';

export const ImageDisplayer = ({img, description, type}) => {

   const widthMap = {
      small: '80%',
      medium: '65%',
      large: '50%',
      xlarge: '100%',
   };

   const mdWidth = widthMap[type];
   
   return (
      <Box
         sx={{
         display: 'flex',
         backgroundColor: 'transparent',
         justifyContent: 'center',
         alignItems: 'center',
         margin: 2,
         width: {xs: '95%', md: mdWidth},
         height: {xs: '100%', md: '80%'},
         maxHeight: {xs: '200px', md: '800px'},
         maxWidth: "100%",
         overflow: 'hidden',
         borderRadius: 5,
         }}
      >
         <img 
            src={img} 
            style={{
               width: '100%',
               objectFit: 'cover'
            }} 
            alt={description}
         />
      </Box>
   )
}

export default ImageDisplayer